var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import { Admin, AdminNav, AdminHeader, AdminBody, AdminSidebar, AdminContent, AdminHeaderSection, AdminHeaderSearch, AdminHeaderAction, NavLogin, NavUser, NavApps, NavAction, NavMenu } from '../';

var layouts = {
    "default": {
        nav: {
            expanded: true
        },
        header: {
            expanded: false
        },
        sidebar: {
            expanded: false
        }
    },
    "dashboard": {
        nav: {
            expanded: true
        },
        header: {
            expanded: true
        },
        sidebar: {
            expanded: false
        }
    },
    "finder": {
        nav: {
            expanded: true
        },
        header: {
            expanded: true
        },
        sidebar: {
            expanded: true
        }
    },
    "finder/search": {
        nav: {
            expanded: true
        },
        header: {
            expanded: true
        },
        sidebar: {
            expanded: true
        }
    },
    "finder/upload": {
        nav: {
            expanded: true
        },
        header: {
            expanded: true
        },
        sidebar: {
            expanded: false
        }
    },
    "finder/action": {
        nav: {
            expanded: true
        },
        header: {
            expanded: true
        },
        sidebar: {
            expanded: false
        },
        action: {
            expanded: false
        }
    },
    "editor": {
        nav: {
            expanded: false
        },
        header: {
            expanded: false
        },
        sidebar: {
            expanded: false
        }
    }
};

var LayoutAdmin = (_temp2 = _class = function (_Component) {
    _inherits(LayoutAdmin, _Component);

    function LayoutAdmin() {
        var _temp, _this, _ret;

        _classCallCheck(this, LayoutAdmin);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            theme: undefined,
            nav: {
                expanded: true
            },
            navApps: {
                expanded: false
            },
            navUser: {
                expanded: false
            },
            header: {
                expanded: false
            },
            sidebar: {
                expanded: false
            },
            search: {
                expanded: false
            },
            action: {
                expanded: false
            }

            // update state

        }, _this.componentDidUpdate = function (prevProps, prevState) {

            if (prevProps.app !== _this.props.app) {
                _this.getApp();
            } else {
                if (prevProps.theme !== _this.props.theme) {
                    _this.getTheme();
                }

                if (prevProps.layout !== _this.props.layout) {
                    _this.getLayout();
                }

                if (prevProps.action !== _this.props.action) {
                    _this.getAction();
                }
            }
        }, _this.getApp = function () {
            var search = _this.props.search || _this.props.app.search || undefined;
            var theme = _this.props.theme || _this.props.app.theme || undefined;
            var layout = _this.props.layout || _this.props.app.layout || undefined;

            var layoutState = void 0;

            if (layouts[layout]) {
                layoutState = layouts[layout];
            } else if ((typeof layout === 'undefined' ? 'undefined' : _typeof(layout)) === 'object' && layout !== null) {
                layoutState = layout;
            } else {
                layoutState = layouts['default'];
            }

            var action = _this.props.action || _this.props.app.action || undefined;

            if (action) {
                action = _extends({}, action, {
                    expanded: true
                });
            }

            _this.setState(_extends({}, _this.state, layoutState, {
                theme: theme,
                search: search,
                action: action,
                navApps: {
                    expanded: false
                },
                navUser: {
                    expanded: false
                }
            }));
        }, _this.getTheme = function () {
            var theme = _this.props.theme || _this.props.app.theme || undefined;

            _this.setState({
                theme: theme
            });
        }, _this.getLayout = function () {
            var layout = _this.props.layout || _this.props.app.layout || undefined;

            var layoutState = void 0;

            if (layouts[layout]) {
                layoutState = layouts[layout];
            } else if ((typeof layout === 'undefined' ? 'undefined' : _typeof(layout)) === 'object' && layout !== null) {
                layoutState = layout;
            } else {
                layoutState = layouts['default'];
            }

            _this.setState(_extends({}, _this.state, layoutState, {
                navApps: {
                    expanded: false
                },
                navUser: {
                    expanded: false
                }
            }));
        }, _this.getAction = function () {
            var action = _this.props.action;


            if (action) {

                _this.setState({
                    action: _extends({}, action, {
                        expanded: true
                    })
                });
            }
        }, _this.onLogin = function (props, event) {
            if (_this.props.onLogin) {
                _this.props.onLogin(props, event);
            }
        }, _this.onLogout = function (props, event) {
            if (_this.props.onLogout) {
                _this.props.onLogout(props, event);
            }
        }, _this.onSelectNav = function (props, event) {
            if (_this.props.onSelectNav) {
                _this.props.onSelectNav(props, event);
            }
        }, _this.onSelectOwner = function (props, event) {
            if (_this.props.onSelectOwner) {
                _this.props.onSelectOwner(props, event);
            }
        }, _this.onSelectApp = function (props, event) {
            if (_this.props.onSelectApp) {
                _this.props.onSelectApp(props, event);
            }
        }, _this.onSearch = function (q, event) {
            _this.setState({
                search: _extends({}, _this.state.search, {
                    q: q
                })
            });

            if (_this.props.onSearch) {
                _this.props.onSearch(q, event);
            }
        }, _this.onToggleSearch = function () {
            _this.setState({
                action: _extends({}, _this.state.action, {
                    expanded: false
                }),
                search: _extends({}, _this.state.search, {
                    expanded: !_this.state.search.expanded
                })
            });

            if (_this.props.onToggleSearch) {
                _this.props.onToggleSearch();
            }
        }, _this.onToggleAction = function () {
            _this.setState({
                search: _extends({}, _this.state.search, {
                    expanded: false
                }),
                action: _extends({}, _this.state.action, {
                    expanded: !_this.state.action.expanded
                })
            });

            if (_this.props.onToggleAction) {
                _this.props.onToggleAction();
            }
        }, _this.onToggleNavUser = function () {
            _this.setState({
                navUser: {
                    expanded: !_this.state.navUser.expanded
                },
                navApps: {
                    expanded: false
                }
            });
        }, _this.onToggleNavApps = function () {
            _this.setState({
                navApps: {
                    expanded: !_this.state.navApps.expanded
                },
                navUser: {
                    expanded: false
                }
            });
        }, _this.renderNavApps = function () {
            var navApps = _this.state.navApps;
            var _this$props = _this.props,
                user = _this$props.user,
                onSelectOwner = _this$props.onSelectOwner,
                onSelectApp = _this$props.onSelectApp;


            if (user && user.apps) {
                return React.createElement(NavApps, _extends({}, user, { expanded: navApps.expanded || false, onToggle: _this.onToggleNavApps, onSelectOwner: _this.onSelectOwner, onSelectApp: _this.onSelectApp }));
            }

            return false;
        }, _this.renderNavUser = function () {
            var navUser = _this.state.navUser;
            var _this$props2 = _this.props,
                app = _this$props2.app,
                user = _this$props2.user;


            if (user && user.uniqueId) {
                return React.createElement(NavUser, { app: app, user: user, expanded: navUser.expanded || false, onToggle: _this.onToggleNavUser, onLogout: _this.onLogout });
            } else {
                return React.createElement(NavLogin, { onLogin: _this.onLogin });
            }

            return false;
        }, _this.renderSidebarAction = function () {
            var button = _this.props.button || _this.props.app.button || undefined;

            if (!button) {
                return false;
            }

            return React.createElement(NavAction, { button: button, align: 'left' });
        }, _this.renderSidebarMenu = function () {
            var menu = _this.props.menu || _this.props.app.menu || undefined;
            var url = _this.props.url || undefined;

            if (!menu) {
                return false;
            }

            return React.createElement(NavMenu, _extends({}, _this.props, { menu: menu, url: url, onSelect: _this.onSelectNav }));
        }, _this.renderHeaderSection = function () {
            var _this$props3 = _this.props,
                app = _this$props3.app,
                user = _this$props3.user,
                owner = _this$props3.owner;


            var title = void 0,
                subtitle = void 0;

            title = app.title || app.name;

            if (owner && owner.uniqueId) {
                subtitle = owner.title || owner.name || "N/A";
            } else if (user && user.uniqueId) {
                subtitle = user.name || "N/A";
            } else {
                subtitle = app.subtitle || "N/A";
            }

            return React.createElement(AdminHeaderSection, _extends({}, app, { title: title, subtitle: subtitle }));
        }, _this.renderHeaderAction = function () {
            var action = _this.state.action;


            if (action) {
                return React.createElement(AdminHeaderAction, _extends({}, action, { onToggle: _this.onToggleAction }));
            }

            return false;
        }, _this.renderHeaderSearch = function () {
            var search = _this.state.search;


            if (search) {
                return React.createElement(AdminHeaderSearch, _extends({}, search, { onToggle: _this.onToggleSearch, onChange: _this.onSearch }));
            }

            return false;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    LayoutAdmin.prototype.componentDidMount = function componentDidMount() {
        this.getApp();
    };

    // login + logout

    // select nav item

    // select owner, select app

    // search

    // action

    // toggle nav

    // navApps + navUser

    // sidebar button + menu

    // header

    LayoutAdmin.prototype.render = function render() {
        var _state = this.state,
            theme = _state.theme,
            nav = _state.nav,
            header = _state.header,
            sidebar = _state.sidebar;


        return React.createElement(
            Admin,
            { theme: theme || undefined },
            React.createElement(
                AdminNav,
                { expanded: nav.expanded || false },
                this.renderNavApps(),
                this.renderNavUser()
            ),
            React.createElement(
                AdminHeader,
                { expanded: header.expanded || false },
                this.renderHeaderSection(),
                this.renderHeaderAction(),
                this.renderHeaderSearch()
            ),
            React.createElement(
                AdminBody,
                null,
                React.createElement(
                    AdminSidebar,
                    { expanded: sidebar.expanded || false },
                    this.renderSidebarAction(),
                    this.renderSidebarMenu()
                ),
                React.createElement(
                    AdminContent,
                    null,
                    this.props.children
                )
            )
        );
    };

    return LayoutAdmin;
}(Component), _class.defaultProps = {
    app: {
        title: "App",
        subtitle: "Owner or user",
        theme: undefined,
        layout: undefined,
        version: 0.1
    },
    theme: undefined,
    layout: undefined,
    action: undefined,
    user: {
        uniqueId: undefined
    },
    owner: {
        uniqueId: undefined
    }
}, _temp2);


export default LayoutAdmin;